<script>
    import { fade, fly } from 'svelte/transition';
    import { t, locale, locales } from "./i18n";
    export let Produkt="000000";
    export let Haushalte=1;
    export let Frequenz=0;
    export let BasPlus =0;
    export let Volumen=0;
    export let Säcke=0;

    $: { 
        // console.log(this);
        Volumen = ((((BasPlus / Frequenz)*Haushalte)+0.5) | 0);}
    $: { Säcke = (Produkt==="300198" ? (((Volumen/60)+0.5)|0) : 0);}


</script>
<!-- {#if Produkt != "000000"} -->
    <tr>
        <td style="text-align: left"> 
        
            {#key Produkt}
            <span style="display: inline-block" in:fly={{ y: -20 }}>
            {$t(Produkt)}
            </span>
            {/key}
            
        </td>
        <td style="text-align: center"> 
            {#key Frequenz}
            <span style="display: inline-block" in:fly={{ y: -20 }}>
            {Frequenz}
            </span>
            {/key}
        </td>
        <td style="text-align: right; padding-left: 90px"> 
            {#key Volumen}
            <span style="display: inline-block;" in:fly={{ y: -20 }}>
            {Haushalte > 0 && Haushalte <= 1000 ? Volumen : 0}
            </span>
            {/key}
        </td>
        <td style="text-align: left">
            {#key Säcke}
            <span style="display: inline-block;" in:fly={{ y: -20 }}>
                {#if Säcke > 0 && Haushalte > 0 && Haushalte <= 1000}({Säcke} {$t("table.säcke")}){/if}
            </span>
            {/key}
        </td>
    </tr>

<!-- {/if} -->

<style>
    stretchColumns { 
		width:50%;
	}
  
</style>

